import firebase from "firebase";
//import 'firebase/firestore'
//import 'firebase/storage'


// Initialize Firebase
 var config = {
    apiKey: "AIzaSyCJ6lo7miolKTIAbsY9b93LZZ9pWq18hXM",
    authDomain: "elatukku-23ef3.firebaseapp.com",
    databaseURL: "https://elatukku-23ef3.firebaseio.com",
    projectId: "elatukku-23ef3",
    storageBucket: "elatukku-23ef3.appspot.com",
    messagingSenderId: "141186804346",
    appId: "1:141186804346:web:bd8932572ca3578c33e9c3",
    measurementId: "G-119K7GRQT3"
 };

 const firebaseApp = firebase.initializeApp(config);
// firebase.functions().useFunctionsEmulator("http://localhost:8080");
 firebaseApp.firestore().settings({ timestampsInSnapshots:true})

 export default firebaseApp.firestore()



// WEBPACK FOOTER //
// ./src/firebase/init.js